import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AccountService } from '../../../services/account.service';
import { WatchAccountService } from '../../../services/watch-account.service';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs';
import { IAccount } from '../../../interfaces/graph-types';

@Component({
  selector: 'modal-create-group',
  template: require('./modal-create-group.component.pug'),
  styles: [require('./modal-create-group.component.css').toString()],
})
export class ModalCreateGroupComponent implements OnInit {
  name: string = null;
  icon = 'fal fa-user-edit';
  sharing = 2;
  rejectPreviouslyContacted = false;
  verifyEmails = false;
  verifyEmailsDisabled = true;
  rejectRiskyEmails = false;
  rejectUnknownEmails = false;
  rejectInvalidEmails = false;
  emailVerificationProvider: string;

  sub: Subscription = null;
  account: IAccount;
  zerobounceApi: string;
  briteverifyApi: string;
  neverbounceApi: string;
  hunterApi: string;
  dropcontactApi: string;
  emailVerificationCredits: number;

  public reason: Subject<any>;

  iconList = [
    'fal fa-user-edit',
    'fal fa-database',
    'fal fa-info',
    'fal fa-flask',
    'fal fa-bolt',
    'fal fa-comment-alt-smile',
  ];

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private accountService: AccountService,
    private watch: WatchAccountService,
    private watchAcccount: WatchAccountService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.reason = new Subject();

    this.sub = this.accountService
      .getAddonsInfo(this.watchAcccount.accountId().getValue())
      .subscribe(account => {
        this.account = account;
        this.briteverifyApi = account.briteverifyApi;
        this.dropcontactApi = account.dropcontactApi;
        this.hunterApi = account.hunterApi;
        this.neverbounceApi = account.neverbounceApi;
        this.zerobounceApi = account.zerobounceApi;
        this.emailVerificationCredits = account.emailVerificationCredits;

        if (this.getEmailVerificationProvider())
          this.verifyEmailsDisabled = false;
      });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  getVerifyEmailLabel() {
    if (this.verifyEmailsDisabled) return '';
    if (!this.verifyEmails)
      return 'Using one of your email verification add-ons';

    return '';
  }

  // -------------------------------------------------------------------
  getEmailVerificationProvider() {
    if (this.emailVerificationCredits) return 'quickmail';
    if (this.briteverifyApi) return 'briteverify';
    if (this.dropcontactApi) return 'dropcontact';
    if (this.hunterApi) return 'hunter';
    if (this.neverbounceApi) return 'neverbounce';
    if (this.zerobounceApi) return 'zerobounce';

    return null;
  }

  // -------------------------------------------------------------------
  canSave() {
    if (!this.name) return false;

    if (this.verifyEmails && !this.emailVerificationProvider) return false;

    return true;
  }

  // -------------------------------------------------------------------
  setIcon(icon) {
    this.icon = icon;
  }

  // -------------------------------------------------------------------
  iconClass(icon) {
    let newClass = {};
    newClass[icon] = true;
    return newClass;
  }

  // -------------------------------------------------------------------
  ClickRejectPreviouslyContacted(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.rejectPreviouslyContacted = !this.rejectPreviouslyContacted;
    onsuccess();
  }

  // -------------------------------------------------------------------
  ClickRejectRiskyEmails(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.rejectRiskyEmails = !this.rejectRiskyEmails;
    onsuccess();
  }

  // -------------------------------------------------------------------
  ClickRejectUnknownEmails(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.rejectUnknownEmails = !this.rejectUnknownEmails;
    onsuccess();
  }

  // -------------------------------------------------------------------
  ClickVerifyEmails(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.verifyEmails = !this.verifyEmails;

    if (this.verifyEmails) {
      const provider = this.getEmailVerificationProvider();
      if (provider) {
        this.emailVerificationProvider = provider;
      } else {
        this.verifyEmailsDisabled = true;
        this.verifyEmails = false;
      }
    } else {
      this.emailVerificationProvider = null;
    }

    onsuccess();
  }

  // -------------------------------------------------------------------
  ClickRejectInvalidEmails(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.rejectInvalidEmails = !this.rejectInvalidEmails;
    onsuccess();
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    let acc_id = this.watch.accountId().getValue();

    this.accountService.createGroup(
      acc_id,
      this.name,
      this.icon,
      this.sharing,
      this.rejectPreviouslyContacted,
      this.verifyEmails,
      this.rejectRiskyEmails,
      this.rejectUnknownEmails,
      this.rejectInvalidEmails,
      this.emailVerificationProvider,
      result => {
        this.reason.next(true);
        this.bsModalRef.hide();
        //onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }
}
